/*
 * Copyright (c) 2026 Centrica.  All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * Date: 2026-10-01
 */

import { Injectable } from '@angular/core';
import { API_CONFIG, BaseCrudService } from '@nebula-shared/data-access';
import { Cuipo } from './cuipo.models'; // Asegúrate de que la ruta sea correcta

@Injectable({ providedIn: 'root' })
export class CuipoService extends BaseCrudService<Cuipo> {
  constructor() {
    super();
    // NOTA: Asegúrate de que API_CONFIG tenga la propiedad 'presupuesto'
    // y que el endpoint 'cuipos' apunte a: /presupuesto/parametros/cuipo
    const config = API_CONFIG.budget;
    this.setBaseUrl(`${config.baseUrl}${config.endpoints.cuipos}`);
  }

  /**
   * Ruta del page-response de CUIPO, la que consulta la ventana de busqueda de maestros; el
   * endpoint del recurso ya es el page-response y el servidor pagina, busca y ordena.
   *
   * @returns la ruta completa del page-response de CUIPO
   */
  get rutaDePageResponse(): string {
    return this.baseUrl;
  }
}
